class YearsAccordionItem {
  constructor(el) {
    this.el = el;
    this.button = el.querySelector('.years-accordion__item-button');
    this.panel = el.querySelector('.years-accordion__item-panel');
    this.subitems = this.panel.querySelectorAll('.years-accordion__item-year-detail');

    this.button.addEventListener('click', () => this.toggle());
    
    this.panel.addEventListener('subaccordion:changed', () => this.recalculateHeight());
  }

  toggle() {
    const expanded = this.button.getAttribute('aria-expanded') === 'true';

    if (expanded) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    //console.log('open Prime');
    this.button.setAttribute('aria-expanded', 'true');
    this.panel.style.transition = 'height .2s ease-in-out, opacity .3s ease-in-out .1s';
    this.recalculateHeight();
    this.panel.style.opacity = '1';
    this.el.classList.add('expanded');

    if (window.innerWidth > 768) {
      this.panel.querySelectorAll('.years-subaccordion__item-button').forEach((subBtn) => {
        subBtn.setAttribute('aria-expanded', 'true');
      });
      this.panel.querySelectorAll('.years-accordion__item-year-detail').forEach((detail) => {
        detail.classList.add('expanded');
      })
    }
  }

  close() {
    //console.log('close Prime');
    this.button.setAttribute('aria-expanded', 'false');
    this.panel.style.transition = 'height .2s ease-in-out, opacity .3s ease-in-out .1s';
    this.panel.style.height = '0px';
    this.panel.style.opacity = '0';
    this.el.classList.remove('expanded');

    // Cerrar todos los subacordeones si estamos en móvil
    if (window.innerWidth <= 768) {
      this.subitems.forEach((subitem) => {
        subitem.classList.remove('expanded');
        const btn = subitem.querySelector('.years-subaccordion__item-button');
        const panel = subitem.querySelector('.years-subaccordion__item-panel');
        btn.setAttribute('aria-expanded', 'false');
        panel.style.height = '0px';
        panel.style.opacity = '0';
      });
    }
  }

  recalculateHeight() {
    console.log('recalculatePrime');
    let totalHeight = 0;

    this.subitems.forEach((subitem) => {
      if (window.innerWidth <= 768) { 
        const subButton = subitem.querySelector('.years-subaccordion__item-button');
        if (subButton) {
          totalHeight += subButton.scrollHeight;
        }
        const subPanel = subitem.querySelector('.years-subaccordion__item-panel');
        if (subPanel && subitem.classList.contains('expanded')) {
          totalHeight += subPanel.scrollHeight;
          totalHeight += 30;
        }
      }else {
        totalHeight += 100;

        const subPanels = subitem.querySelectorAll('.years-subaccordion__item-panel');

        subPanels.forEach((subPanel) => {
          totalHeight += subPanel.scrollHeight;
        });
      }
    });

    this.panel.style.height = `auto`;
    
  }
}

class YearsAccordionSubItem {
  constructor(el) {
    this.el = el;
    this.button = el.querySelector('.years-subaccordion__item-button');
    this.panel = el.querySelector('.years-subaccordion__item-panel');

    this.toggleHandler = () => this.toggle();

    this.init();
  }

  init() {
    this.button.addEventListener('click', this.toggleHandler);
  }

  toggle() {
    const expanded = this.button.getAttribute('aria-expanded') === 'true';
    expanded ? this.close() : this.open();
  }

  open() {
    //console.log('open Sub');
    this.el.classList.add('expanded');
    this.button.setAttribute('aria-expanded', 'true');
    //this.panel.style.transition = 'height .2s ease-in-out, opacity .3s ease-in-out .1s';
    this.panel.style.height = 'auto';
    this.panel.style.opacity = '1';
    
    this.el.dispatchEvent(new CustomEvent('subaccordion:changed', { bubbles: true }));
  }

  close() {
    //console.log('close sub');
    this.el.classList.remove('expanded');
    this.button.setAttribute('aria-expanded', 'false');
    //this.panel.style.transition = 'height .2s ease-in-out, opacity .3s ease-in-out .1s';
    this.panel.style.height = '0px';
    this.panel.style.opacity = '0';

    this.el.dispatchEvent(new CustomEvent('subaccordion:changed', { bubbles: true }));
  }
}

let subItemsInstances = [];

const initYearAccordions = () => {
  document.querySelectorAll('.years-accordion__item').forEach((el) => new YearsAccordionItem(el));

  subItemsInstances = [];
  document.querySelectorAll('.years-accordion__item-year-detail').forEach((el) => {
    subItemsInstances.push(new YearsAccordionSubItem(el));
  });
};

let initialWidth = window.innerWidth;

window.addEventListener('resize', () => {
  if(initialWidth != window.innerWidth) {
    initialWidth = window.innerWidth;
    if (window.innerWidth < 768) {
      const allButtons = document.querySelectorAll('.years-accordion__body-accordion button');
      allButtons.forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
      });
  
      const allPrimePanels = document.querySelectorAll('.years-accordion__item-panel');
      allPrimePanels.forEach((panel) => {
        panel.style.height = '0px';
        panel.style.opacity = '0';
      });
  
      const allSecondPanels = document.querySelectorAll('.years-subaccordion__item-panel');
      allSecondPanels.forEach((secPanel) => {
        secPanel.style.height = '0px';
        secPanel.style.opacity = '0';
      });
  
      const wrappers = document.querySelectorAll('.years-accordion__item');
      wrappers.forEach((wrap) => {
        wrap.classList.remove('expanded');
      });

      const subwrappers = document.querySelectorAll('.years-accordion__item-year-detail');
      subwrappers.forEach((subwrap) => {
        subwrap.classList.remove('expanded');
      });
    }else {
  
      const wrappers = document.querySelectorAll('.years-accordion__item');
      wrappers.forEach((wrap) => {
        wrap.classList.remove('expanded');
      });
      const primeBtns = document.querySelectorAll('.years-accordion__item-button');
      primeBtns.forEach((primeBtn) => {
        primeBtn.setAttribute('aria-expanded', 'false');
      });
  
      const allPrimePanels = document.querySelectorAll('.years-accordion__item-panel');
      allPrimePanels.forEach((panel) => {
        panel.style.height = '0px';
        panel.style.opacity = '0';
      });

      const subwrappers = document.querySelectorAll('.years-accordion__item-year-detail');
      subwrappers.forEach((subwrap) => {
        subwrap.classList.add('expanded');
      });

      const subpanels = document.querySelectorAll('.years-subaccordion__item-panel');
      subpanels.forEach((subpanel) => {
        subpanel.style.height = 'auto';
        subpanel.style.opacity = '1';
      });
    }
  }
  
});

initYearAccordions();